
import ApiService from "@/common/ApiService";
import urlConfig from "@/../public/urlConfig.json";
import Vue from "vue";
const apiService = new ApiService(Vue.prototype.$config.hotelBaseAddress);

 const Hotel = {
    RESERVE_URL: "HotelRoom/RESERVE",
    TICKET_URL: "HotelRoom/GetBookById",
    VOUCHER_URL: "HotelRoom/GetVoucherById",

    CREDITBOOK_URL: "HotelRoom/CREDITBOOK",
    GETCREDIT_URL: "HotelRoom/GetCreditsBySourceId",


};
const factory = () => ({
    selectedHotelRoom: {},
    hotelBookingDetails:{},
    hotelDetailData:{}
});

export default {
    namespaced: true,
    state: factory(),
    mutations: {
        SetSelectedHotelRoom(state, item) {
            state.selectedHotelRoom = item;
        },
        SetHotelBookingDetails(state, item) {
            
            state.hotelBookingDetails = item;
        },
        SetHotelDetails(state, item) {
            state.hotelDetailData = item;
        },
        EmptyBookingDetails(state) {
            state.hotelBookingDetails = {};
        },
    },

    getters: {
        GetSelectedHotelRoom(state) {
            return state.selectedHotelRoom;
        },
        GetHotelBookingDetails(state) {
            return state.hotelBookingDetails;
        },
        GetHotelDetails(state) {
            return state.hotelDetailData;
        },
    },

    actions: {
        async getHotelSearch(context, queryString) {
            try {
                const response = await apiService.Get("GetHotelList?" + queryString);

                return (response.data);
            } catch (err) {
                console.log(err);
            }
        },
        async getAllHotelTypes(context, queryString) {
            try {
                const response = await apiService.Get("GetAllHotelTypes?" + queryString);

                return (response.data);
            } catch (err) {
                console.log(err);
            }
        },
        async getFacilityList(context, queryString) {
            try {
                const response = await apiService.Get("GetAllFacilities?" + queryString);

                return (response.data);
            } catch (err) {
                console.log(err);
            }
        },

        async getAvailRoomList(context, queryString) {
            try {
                const response = await apiService.Get("GetAvailRoomList?" + queryString);

                return (response.data);
            } catch (err) {
                console.log(err);
            }
        },

        async Reserve(context, params) {
            const response = await apiService.Post(Hotel.RESERVE_URL, params);

            return response.data.data;
        },
        async CreditBook(context, params) {
            const response = await apiService.Post(Hotel.CREDITBOOK_URL, params);

            return response.data.data;
        },

    async GetCredit(context, params) {
            const response = await apiService.Post(Hotel.GETCREDIT_URL, params);
    return response.data;
        },
        async GetTicket(context, params) {
            const response = await apiService.Post(Hotel.TICKET_URL, params);

            return response.data.data;
        },
        async GetVoucher(context, params) {
            const response = await apiService.Post(Hotel.VOUCHER_URL, params);

            return response.data.data;
        },
        SelectedHotelRoom(context, item) {
            context.commit("SetSelectedHotelRoom", item);
        },
        HotelBookingDetails(context, item) {
            
            context.commit("SetHotelBookingDetails", item);
        },
        HotelDetails(context, item) {
            context.commit("SetHotelDetails", item);
        },

        BookingDetailsEmpty(context) {
            context.commit("EmptyBookingDetails");
        },

    }
}